import { resolveApiError } from './resolve-api-error'

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const resolvedError = resolveApiError(error, fallback)

  return resolvedError.type === 'toast' ? resolvedError.message : resolvedError.summary
}
